import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { useFlowEditorContext } from '../../FlowEditor/context';
import Drawer from '../../Drawer';
import { DetailDrawer } from '../../DetailDrawer';
import FlowTestLogs from './FlowTestLogs';

const FlowTestDetailsDrawer = () => {
  const { t } = useTranslation();
  const { selectedNodeData, setSelectedNodeId, testFlowInstance } = useFlowEditorContext();
  const onClose = () => setSelectedNodeId(null);
  const open = Boolean(selectedNodeData);
  const logs = testFlowInstance?.logs?.sort((a, b) => new Date(a?.ts) - new Date(b?.ts));

  return (
    <Drawer
      open={open}
      position="absolute"
      right="24px"
      bottom="24px"
      top="104px"
      height="100vh"
      borderRadius="8px"
      boxShadow="0px 0px 8px rgba(0, 0, 0, 0.05)"
      fixed
    >
      <DetailDrawer
        open={open}
        title={t(selectedNodeData?.name)}
        onClose={onClose}
        footer={<Box color="#E6E9EC" />}
        content={<FlowTestLogs logs={logs} />}
      />
    </Drawer>
  );
};

export { FlowTestDetailsDrawer };
